module.exports = __webpack_public_path__ + "img/tournament-bg_960.858368c2.png";